const spUp = async (updates, attributes = {}) => {
  window.spU = true;
  const cart = document.querySelector('cart-items-component');
  const sid = cart?.dataset.sectionId || 'cart-drawer';
  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, attributes, sections: sid, sections_url: location.pathname })
    });
    const data = await res.json();
    const newCart = new DOMParser().parseFromString(data.sections?.[sid] || '', 'text/html').querySelector('cart-items-component');
    if (cart && newCart) cart.innerHTML = newCart.innerHTML;
    else location.reload();
    if (data.item_count === 0) {
      const i = document.querySelector('cart-icon');
      if (i) { i.classList.remove('header-actions__cart-icon--has-cart'); i.querySelector('.cart-bubble')?.remove(); }
    }
  } catch { location.reload(); }
  setTimeout(() => window.spU = false, 500);
};
const spCheck = () => {
  const d = document.getElementById('sp-cart-data');
  if (!d || window.spU) return;
  const n = +d.dataset.normalItems, c = d.dataset.inCart === 'true', r = d.dataset.rejected === 'true';
  if (n > 0 && !c && !r) spUp({ [d.dataset.vid]: 1 });
  else if (n === 0 && c) spUp({ [d.dataset.vid]: 0 });
};
spCheck();
new MutationObserver(spCheck).observe(document.body, { childList: true, subtree: true });
document.addEventListener('change', (e) => {
  if (e.target?.id !== 'shippingProtectionToggle') return;
  e.target.parentElement.style.opacity = '0.5';
  e.target.style.pointerEvents = 'none';
  spUp({ [e.target.dataset.variantId]: e.target.checked ? 1 : 0 }, { 'sp_rejected': e.target.checked ? 'false' : 'true' });
});